import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';

const useStores = () => useContext(MobXProviderContext);

export default useStores;
